import Vue from 'vue';
import { apiPath } from '@/api/constants';

const negativeKeywordResource = Vue.resource(
  `${apiPath}/adbazaar{/v}{/type}{/itemId}{/action}/`,
  {},
  {
    addBulkNegativeKeyword: {
      method: 'POST',
      params: { v: 'v2', type: 'campaigns', action: 'negative-keywords' },
    },
  },
);

export default negativeKeywordResource;
